const featured = [
  {
    image: "images/service-02.png",
    title: "Free Shipping",
    text: "Free shipping on all US order or order above $200",
  },
  {
    image: "images/service-02.png",
    title: "Support 24/7",
    text: "Contact us 24 hours a day, 7 days a week",
  },
  {
    image: "images/service-03.png",
    title: "Money Return",
    text: "Back guarantee under 5 days",
  },
  {
    image: "images/service-04.png",
    title: "Member Discount",
    text: "First order discount for all members",
  },
  {
    image: "images/service-05.png",
    title: "Online Payment",
    text: "We ensure secure payment with PEV",
  },
];

export default featured;
